import {
  IndianRupee
} from 'lucide-react';

function StatsBox({ title = "Total Receivable (to collect)", text = "", bg = "purple" }) {
  return (
    <div className="col-span-12 md:col-span-4">
      <div className="bg-white px-4 p-3 rounded-lg shadow-md">
        <h3 className={`font-normal text-lg text-${bg}`}>{title}</h3>
        <p className={`text-xl font-semibold text-${bg}`} >&#8377; {parseInt(text, 10) || 0}</p>
      </div>
    </div>
  );
}

export default StatsBox;